import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

const testimonials = [
  {
    name: 'Bhavesh Golaviya',
    designation: 'CEO of Dharmamrut Studio',
    description: `Partnering through Vaishnav to Vaishnav Business Network has taken our startup to the next level. The connections and insights I gained were invaluable for scaling our business.`,
    image: 'assets/images/testimonial/t1.png',
  },
  {
    name: 'Bhautik Golaviya',
    designation: 'Entrepreneur',
    description: `Thanks to Vaishnav to Vaishnav Business Network, I was able to find the perfect mentor. The advice and connections I’ve gained have been instrumental in my career growth.`,
    image: 'assets/images/testimonial/t1.png',
  },
];

const TestimonialsBrand = () => {
  return (
    <div className="testimonial-with-brand bg_image" style={{
        paddingBottom: '30px',
    }}>
      {/* Testimonial Area */}
      <div className="testimonial-brand-area tmp-section-gapTop">
        <div className="container">
          {/* Header Section */}
          <div className="row">
            <div className="col-lg-12">
              <div className="testimonials-button-area">
                <div className="section-head text-align-left">
                  <div className="section-sub-title">
                    <img
                      src="assets/images/services/section-custom-menubar.png"
                      alt="Corporate_service"
                    />
                    <span className="subtitle">Client’s Testimonials</span>
                  </div>
                  <h2 className="title split-collab">
                    What People Say About <br /> Vaishnav to Vaishnav Business Network
                  </h2>
                </div>
                <div className="button-next-prev">
                  <div className="swiper-button-prev" />
                  <div className="swiper-button-next" />
                </div>
              </div>
            </div>
          </div>

          {/* Swiper Section */}
          <div className="row">
            <div className="col-lg-12">
              <div className="swiper-style-one tmp-section-gapBottom">
                <Swiper
                  modules={[Navigation, Pagination, EffectFade, Scrollbar, A11y, Autoplay]}
                  className="mySwiper-portfolio-1"
                  speed={500}
                  slidesPerView={2}
                  spaceBetween={30}
                  loop={true}
                  autoplay={{
                    delay: 5500,
                    disableOnInteraction: false,
                  }}
                  navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }}
                  breakpoints={{
                    1200: { slidesPerView: 2 },
                    900: { slidesPerView: 2 },
                    768: { slidesPerView: 2 },
                    580: { slidesPerView: 1 },
                    450: { slidesPerView: 1 },
                    0: { slidesPerView: 1 },
                  }}
                >
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <div className="single-card card-horizontal">
                        <div className="card-inner">
                          <div className="content">
                            <div className="rating rating-style-three">
                              <div className="stars-group">
                                <div className="star">
                                  <i className="fa-solid fa-star" />
                                  <i className="fa-solid fa-star" />
                                  <i className="fa-solid fa-star" />
                                  <i className="fa-solid fa-star" />
                                  <i className="fa-solid fa-star-half-stroke" />
                                </div>
                              </div>
                            </div>
                            <p className="description">{testimonial.description}</p>
                            <div className="content content-without-bg">
                              {/* <div className="name">{testimonial.name}</div> */}
                              <div className="designation">{testimonial.designation}</div>
                            </div>
                          </div>
                          <div className="thumbnail">
                            <img src={testimonial.image} alt={testimonial.name} />
                            <div className="icon icon-quote" style={{left:'150px'}}>
                              <i className="fa-duotone fa-quote-right" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsBrand;
